import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { NameSearchData, NameSearchFilter } from '../../entities/name-search/name-search.model';
import { DashboardApiService } from '../db-api.service';

@Injectable({
  providedIn: 'root',
})
export class NameSearchApiService extends DashboardApiService {
  nameSearchTeamMembers<T>(organizationId: number, query: string): Observable<T> {
    const url = `/v1/dashboard/organizations/${organizationId}/team_members/name_search?query=${query}`;

    return this._get(url).pipe(
      map((res) => this._handleResponse(res, 'results')),
      catchError((res) => this._handleError(res)),
    );
  }

  nameSearchGroups<T>(query: string): Observable<T> {
    const url = `/v1/dashboard/organizations/${this.embedding.departmentId}/groups/name_search?query=${query}`;

    return this._get(url).pipe(
      map((res) => this._handleResponse(res, 'results')),
      catchError((res) => this._handleError(res)),
    );
  }

  nameSearch<T>(searchFilter: NameSearchFilter): Observable<NameSearchData<T>> {
    const url = `/v1/typeahead/name_search`;

    const searchParams = new URLSearchParams();
    searchParams.set('organization_id', this.embedding.departmentId.toString());

    return this._post(`${url}?${searchParams.toString()}`, searchFilter).pipe(
      map((res) => this._handleResponse(res)),
      catchError((res) => this._handleError(res)),
    );
  }
}
